
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { mapStateToProps, getContext } from '@u';
import rootActions from 'store/root/actions';
import Select from 'bee-adapter/select';
import '@tinper/next-ui/lib/wui-select/src/Select.css'
import {
	MainNav,
	headerDesc,
	leftCon,
	middleCon,
	rightCon,
	languageClass,
} from './MainNav.css';
import LogoSvg from './logo.png';
import LogoenSvg from './logo2.png';

const { setCurrentNot } = rootActions;
@withRouter
@connect(
	mapStateToProps(
		'currLan',
	),
	{
		setCurrentNot,
		// getAllEnableNot,
		// getCurrentNot,
	},
)
class MainNavPanel extends Component {
	constructor(props) {
		super(props);
		this.state = {
			defaultValue: 'zh_CN',
			languageList: [
				{
					value: 'zh_CN',
					context: lang.template("P_YS_FED_FW_0000020962") /* "简体中文" */
				},
				{
					value: 'en_US',
					context: 'English'
				},
				{
					value: 'zh_TW',
					context: lang.template("P_YS_PF_GZTSYS_0000109539") /* "繁體中文" */
				},
			],
		}
	}
	componentDidMount() {
		//  //获取默认
		//  this.getCurrentLan();
		//新增 添加多语的所有语言
		this.getAllEnableFunc();
	}

	getAllEnableFunc = () => {
		let currentLan = window.getCurrentLangCode ? window.getCurrentLangCode() : "zh_CN";
		this.setState({
			defaultValue: currentLan ? currentLan : 'zh_CN',
		}, () => { this.props.lanCallBack(currentLan) })
		// let allLanArr = window.getEnableLangVOs && window.getEnableLangVOs();
		// let languageListVal = [];
		// if (allLanArr && allLanArr.length) {
		//   allLanArr.map((item) => {
		//     item = { value: item.langCode, context: item.dislpayName }
		//     languageListVal.push(item);
		//   });
		//   this.setState({
		//     languageList: languageListVal,
		//     defaultValue: currentLan ? currentLan : 'zh_CN',
		//   }, () => { this.props.lanCallBack(currentLan) })
		// }
	}

	onChangeLanguage = (value) => {
		this.props.setCurrentNot(value).then(({ error, payload }) => {
			if (error) {
				return;
			}
			window.location.reload();
		});
	}

	open = (type) => {
		if (type == 'service') {
			this.props.activeIndex !== '2' && this.props.history.push('/service')
		} else if (type == 'aboutus') {
			this.props.activeIndex !== '4' && this.props.history.push('/aboutus')
		} else if (type == 'login') {
			this.props.activeIndex !== '1' && this.props.history.push('/')
		} else if (type == 'open') {
			window.open('https://open.diwork.com');
		}else if(type == 'sfzx'){
			window.open('/sfzx/biznews.html');
		}
	}
	goToHome = () => {
		this.props.match && this.props.match.path !== '/' && this.props.history.push('/');

	}
	handleChange = (value) => {
		this.onChangeLanguage(value);
	}
	render() {
		const { currentLan } = this.props;
		const { defaultValue, languageList } = this.state;
		const { productLine } = getContext();
		return (
			<div className={MainNav} id="MainNav">
				<div className={leftCon} onClick={this.goToHome} >
					{currentLan === 'en_US' ? <img src={LogoenSvg} className="companylogoSvg en" /> : <img src={LogoSvg} className="companylogoSvg" />}
				</div>
				<div className={middleCon}>
					<a className={`middleItem ${this.props.activeIndex * 1 === 1 ? 'actived' : null}`} onClick={() => { this.open('login') }}>{lang.template("P_YS_FED_EXAMP_0000020016") /* "首页" */}</a>
					<a className={`middleItem ${this.props.activeIndex * 1 === 2 ? 'actived' : null}`} onClick={() => { this.open('service') }}>{lang.template("P_YS_SD_SDMB_0000146348") /* "服务支持" */}</a>
					<a className={`middleItem ${this.props.activeIndex * 1 === 3 ? 'actived' : null}`} onClick={() => { this.open('open') }}>{lang.template("P_YS_PF_GZTSYS_0000012336") /* "开放平台" */}</a>
					<a className={`middleItem ${this.props.activeIndex * 1 === 4 ? 'actived' : null}`} onClick={() => { this.open('aboutus') }}>{lang.template("P_YS_OA_XTTMCENTER_0000035034") /* "联系我们" */}</a>
				</div>
				{
					this.props.btnShow ?
						(
							<div className={rightCon}>
								<a className="loginBtn" onClick={this.props.loginClick}>{lang.template("P_YS_FED_UCFBASEDOC_0000025215") /* "登录" */}</a>
								{window._IUAPPREMISESFLAG ? null : <a className="registryBtn" target="_blank" href={this.props.registryUrl}>{lang.template("P_YS_FED_UCFBASEDOC_0000025253") /* "立即注册" */}</a>}
							</div>
						) : (
							<div className={`${rightCon} ${languageClass}`}>
								<Select
									value={defaultValue}
									onChange={this.handleChange}
									dropdownClassName={"gnoreclass"}
									style={{ width: "90px" }}
                  bordered={false}
                  showArrow
								>
									{
										languageList.map((item, index) => {
											return (
												<Option value={item.value} key={index}>{item.context}</Option>
											)
										})
									}
								</Select>
							</div>
						)
				}
			</div>
		)
	}

}


export default MainNavPanel;
